import script from "./DownloadPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./DownloadPage.vue?vue&type=script&setup=true&lang=ts"

import "./DownloadPage.vue?vue&type=style&index=0&id=0bbc062f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0bbc062f"]])

export default __exports__